import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconChevronLeft(props: IconProps) {
	return (
		<Icon {...props}>
			<path
				fill="currentColor"
				d="M14.7 2.45a.8.8 0 0 1 .57-.23h2.53c.73 0 1.1.87.58 1.4L15.87 6.1l-5.23 5.33c-.24.27-.17.96 0 1.16l5.2 5.31 2.52 2.49a.82.82 0 0 1-.57 1.4H15.2a.8.8 0 0 1-.58-.24l-9.01-8.96a.8.8 0 0 1 0-1.16z"
			/>
		</Icon>
	);
}
